module.exports = __webpack_public_path__ + "img/id-gok.8eaa974.png";